import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { JanusService, StateService } from '@shared/services';
import { BehaviorSubject, Subject } from 'rxjs';
import { CustomizationService } from '../../../services/customization.service';
import { takeUntil } from 'rxjs/operators';
import { TokenService } from '@shared/services/token.service';
import { PlatformDetectorService } from '@shared/services/platform-detector/platform-detector.service';
import { PopupService } from '@shared/services/popup/popup.service';

@Component({
  selector: 'thevatra-zwift-share-control',
  templateUrl: './zwift-share-control.component.html',
  styleUrls: ['./zwift-share-control.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ZwiftShareControlComponent implements OnInit, OnDestroy {
  public isZwiftShareClicked = false;
  public showZwiftShareButton$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  private readonly destroyed$ = new Subject<boolean>();

  constructor(
    public readonly stateService: StateService,
    private readonly janusService: JanusService,
    private readonly customizationService: CustomizationService,
    private readonly tokenService: TokenService,
    private readonly platformDetectorService: PlatformDetectorService,
    private readonly popupService: PopupService
  ) {}

  ngOnInit(): void {
    this.handleHostForShowingZwiftButton();
  }

  public toggleShareScreen(): void {
    const isZwiftShareEnabled = this.stateService.isZwiftShareEnabled;
    this.stateService.isZwiftShareEnabled = !isZwiftShareEnabled;

    if (this.platformDetectorService.isSafariDesktop()) {
      // this.popupService.dialog(ScreenShareNotAvailablePopupComponent);
      this.janusService.switchSafariShareScreen(!isZwiftShareEnabled, true);
      return;
    }

    this.janusService.switchShareScreen(!isZwiftShareEnabled, true);
    this.stateService.isParticipantsShown = false;
    this.isZwiftShareClicked = !this.isZwiftShareClicked;
  }

  private handleHostForShowingZwiftButton(): void {
    this.tokenService.isHost$.pipe(takeUntil(this.destroyed$)).subscribe(this.showZwiftShareButton$);
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
